import { Record } from 'immutable'
import {
  AssociatedDevelopmentClient,
  IAssociatedDevelopmentClient,
} from './AssociatedDevelopmentClient'
import {
  AssociatedDevelopmentSite,
  IAssociatedDevelopmentSite,
} from './AssociatedDevelopmentSite'
import { EarnestMoney, IEarnestMoney } from './EarnestMoney'

export interface IDevelopmentEarnestMoneySummary {
  readonly client: IAssociatedDevelopmentClient
  readonly site: IAssociatedDevelopmentSite
  readonly earnestMoney: IEarnestMoney
}

const DevelopmentEarnestMoneySummaryRecord = Record({
  client: undefined,
  earnestMoney: undefined,
  site: undefined,
})

export class DevelopmentEarnestMoneySummary
  extends DevelopmentEarnestMoneySummaryRecord
  implements IDevelopmentEarnestMoneySummary {
  public static fromJS(
    initialState?: Partial<IDevelopmentEarnestMoneySummary>,
  ) {
    if (!initialState) {
      return new DevelopmentEarnestMoneySummary()
    }

    const { client, earnestMoney, site } = initialState

    return new DevelopmentEarnestMoneySummary({
      client: AssociatedDevelopmentClient.fromJS(client),
      earnestMoney: EarnestMoney.fromJS(earnestMoney),
      site: AssociatedDevelopmentSite.fromJS(site),
    })
  }

  public readonly client: AssociatedDevelopmentClient
  public readonly site: AssociatedDevelopmentSite
  public readonly earnestMoney: EarnestMoney

  constructor(initialState?: Partial<DevelopmentEarnestMoneySummary>) {
    initialState ? super(initialState) : super()
  }
}
